export const NEW_PRODUCT_URL_PARAM = "new_product";

export enum ShopifySubscriptionType {
  SUPPORT_BASE = "supportBase",
  SUPPORT_AI = "aiMessageSuggestion",
  ORDER_TRACKING = "orderTracking",
  TEXT_MESSAGING = "textMessaging",
  /**
   * @deprecated, falls under CHECKOUT_OPTIMIZATION
   */
  ONE_CLICK_UPSELL = "oneClickUpsell",
  MARKETING = "marketing",
  RECOVER = "recover",
  CHECKOUT_OPTIMIZATION = "checkoutOptimization",
  SUPPORT_VOICE = "supportVoice",
  AI_EXCHANGE_AGENT = "aiExchangeAgent",
  RETURNS = "returns",
  AEO = "aeo",
  IMS = "ims",
  DISPUTES = "disputes",
}

export interface CancelShopifySubscriptionBody {
  subscriptionType: ShopifySubscriptionType;
}
